import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ux-ui',
  templateUrl: './ux-ui.component.html',
  styleUrls: ['./ux-ui.component.scss'],
})
export class UxUiComponent implements OnInit {
  modulesText = {
    text: 'Lo scopo del corso è di introdurre gli studenti al mondo della User Experience e della User Interface, fornendo loro un piccolo brief di progetto su cui fare pratica affiancati dall’insegnante e illustrando i concetti base attraverso materiali didattici (presentazioni digitali, libri sull’argomento, incontri con professionisti del settore).',
  };

  constructor() {}

  ngOnInit(): void {}
}
